import React, { useEffect, useMemo, useRef } from "react";
import { Splide, SplideSlide } from "@splidejs/react-splide";

import { useSelector } from "react-redux";
import { iconFilter } from "../MenuBar/components/iconFilter";
import { useLocation, useNavigate, useParams } from "react-router";
import { HiArrowNarrowLeft } from "react-icons/hi";
import useSubTypeList from "../../hook/useSubTypeList";
import { Link } from "react-router-dom";
import useCasinoType from "../../hook/useCasinoType";
import { useTranslation } from "react-i18next";
import LoadingImage from "../../components/Loading/LoadingImage";
import LoadingLine from "../../components/Loading/LoadingLine";
import i18next from "i18next";
import { colorSelector } from "./utils/colorSelector";
import { handleTriggerMenu } from "../../hook/useTriggerMenu";
import { hiddenSelectIcon } from "../../hook/useHiddenSelectIcon";

const ListSelect = () => {
  const { t } = useTranslation();
  const i18n = (key) => t(`common.${key}`);

  const isHandleAllGame = useSelector((state) => state.isHandleAllGame);
  const { game_subtype, sortedByPlatformAndCategoryGames } = isHandleAllGame;

  const splideRef = useRef();

  const subList = useSubTypeList();
  const casinoType = useCasinoType();

  const navigate = useNavigate();
  const location = useLocation();

  const { gamePlatform, subType } = useParams();
  const { pathname } = location;

  useEffect(() => {
    if (subType && splideRef.current) {
      const splide = splideRef.current.splide;

      splide.go(subList?.indexOf(subType));
    }
  }, []);

  const gameSubTypeList = useMemo(() => {
    if (subList) {
      return [
        // // 首頁按鈕
        // <SplideSlide key="home">
        //   <Link
        //     to={`/${casinoType}`}
        //     className={`min-h-[50px] text-center rounded-[10px] active:scale-[0.95] hover:!text-white overflow-hidden relative p-[5px] gap-[5px] flex flex-col items-center justify-center text-white bg-gradient-to-b from-[#ffb47d] to-[#ff6d01]`}
        //   >
        //     {iconFilter("Home", { custom: "!mr-0" })}
        //     <span className="text-xs font-semibold text-overflow tracking-tighter w-full text-overflow">
        //       {i18n("BackToLobby")}
        //     </span>
        //   </Link>
        // </SplideSlide>,
        // 子類型按鈕
        ...subList.map((item, index) => {
          const hiddenIcon = hiddenSelectIcon({
            iconName: item,
            casinoType: casinoType,
          });
          const listClassName = handleTriggerMenu(
            "border-2 border-main-color",
            item,
            {
              pathname,
              casinoType,
              subType,
            }
          );
          return (
            <SplideSlide key={index}>
              <Link
                to={
                  item === "Home"
                    ? `/${casinoType}`
                    : item === "AllGames" &&
                      gamePlatform !== "all" &&
                      gamePlatform
                    ? `/${casinoType}/category/${gamePlatform}/AllGames`
                    : `/${casinoType}/category/${gamePlatform || "all"}/${item}`
                }
                className={`${listClassName} ${hiddenIcon} h-[50px] text-center rounded-[10px] active:scale-[0.95] hover:!text-white overflow-hidden relative p-[5px] gap-[5px] flex flex-col items-center justify-center text-white ${colorSelector(
                  { index: index }
                )}`}
              >
                <LoadingImage className={`w-[18px] h-[18px] rounded-full`}>
                  {iconFilter(item, { custom: "!mr-0" })}
                </LoadingImage>
                <LoadingLine className={`!w-[30px] !h-[5px] !mt-0`}>
                  <span className="text-xs font-semibold text-overflow tracking-tighter w-full text-overflow">
                    {i18n(item)}
                  </span>
                </LoadingLine>
              </Link>
            </SplideSlide>
          );
        }),
      ];
    }
  }, [subList, pathname, i18next.language]);

  return (
    <Splide
      ref={splideRef}
      options={{
        pagination: false,
        arrows: false,
        drag: "free",
        perPage: 6,
        perMove: 1,
        gap: 10,
        lazyLoad: "nearby",
        dragMinThreshold: {
          mouse: 0,
          touch: 10,
        },
      }}
    >
      {/* {gamePlatform && gamePlatform !== "all" ? (
        <SplideSlide>
          <Link
            to={`/${casinoType}`}
            className={`text-center text-[#535353] h-[50px] bg-[#eee] rounded-[10px] p-[5px] gap-[5px] flex flex-col items-center justify-center`}
          >
            {iconFilter("Home", { custom: "!mr-0" })}
            <HiArrowNarrowLeft className="text-2xl mr-[10px] group-hover:text-main-color !mr-0" />
            <span className="text-xs font-semibold text-overflow tracking-tighter w-full text-overflow">
              Back To Lobby
            </span>
          </Link>
        </SplideSlide>
      ) : null}
 */}
      {gameSubTypeList}
    </Splide>
  );
};

export default ListSelect;
